var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTestingAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "58px",
    viewBox: "0 0 50 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8567074A-4F32-4F78-A807-45FD1D53DD7F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-T-P8",
    transform: "translate(-858, -580)",
    stroke: "#F7F7F8",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "family",
    transform: "translate(750, 550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(74, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-assessment",
    transform: "translate(36, 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5390288,7.12845763 L30.5400402,7.12845763 C34.3302797,7.12845763 37.4028935,10.2017669 37.4028935,13.9928644 L37.4028935,47.1355932 C37.4028935,50.9266907 34.3302797,54 30.5400402,54 L6.86285327,54 C3.07261379,54 0,50.9266907 0,47.1355932 L0,13.9928644 C0,10.2017669 3.07261379,7.12845763 6.86285327,7.12845763 L9.90000898,7.12845763",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9722896,4.06796186 C23.3626395,1.72765678 21.2338968,0 18.7015039,0 C16.1691111,0 14.0403684,1.72765678 13.4307182,4.06796186 L10.1468429,4.06796186 L10.1468429,11.2856568 L27.2560505,11.2856568 L27.2560505,4.06796186 L23.9722896,4.06796186 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8.59252105 43.2868347 10.8334714 45.3693814 14.1475432 41.6605424"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.282595,
    y1: 29.5227839,
    x2: 8.88476422,
    y2: 33.9216102,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.282595,
    y1: 33.9216102,
    x2: 8.88476422,
    y2: 29.5227839,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.0377978,
    y1: 31.7221398,
    x2: 28.8103724,
    y2: 31.7221398,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.0377978,
    y1: 43.5149619,
    x2: 28.8103724,
    y2: 43.5149619,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59252105,
    y1: 19.9700466,
    x2: 28.8103724,
    y2: 19.9700466,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.604547,
    y1: 15.3937754,
    x2: 46.5847048,
    y2: 15.3937754,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7307692,44.5042549 L46.7307692,10.4193686 C46.7307692,7.84304237 44.6426317,5.7544322 42.0668885,5.7544322 C39.4911453,5.7544322 37.4030078,7.84304237 37.4030078,10.4193686 L37.4030078,45.6118093 C37.4030078,47.8499492 38.2633809,50.0023983 39.8059215,51.6236568 L42.0667742,54 L44.3277412,51.6236568 C45.8702818,50.0023983 46.7306548,47.8499492 46.7306548,45.6118093 L46.7306548,44.5218559 L37.5460983,44.5218559",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestingAssessment);
export default __webpack_public_path__ + "static/media/icon-testing-assessment.6ffb3dc2f496744958f2522911d24d29.svg";
export { ForwardRef as ReactComponent };